import MutableTrack from './MutableTrack.js';
import FreezableTrack from "track/freeze/FreezableTrack.js";
import TriggerableTrack from "track/TriggerableTrack.js";
import Tone from 'tone';
import SoundUploader from 'api/SoundUploader.js';
import Sampler from 'instruments/Sampler.js';
import Sample from 'repos/Sample.js';
import {getMilliseconds} from './getMilliseconds.js';

const DELAY = 0;
const OVERLAP = 10;

class RecordableTrack extends FreezableTrack(TriggerableTrack(MutableTrack)) {
    constructor(trackNumber, sequencerEngine, mixSession, numberOfPatterns, update, subSequence) {
        super(trackNumber, sequencerEngine, mixSession, numberOfPatterns, update, subSequence);
        this.audioInputChannel = undefined;
        this.isRecording = false;
        this.samplesToUpload = [];

        this.soundUploader = new SoundUploader(
            1, (soundId, ipfsHash, loopNumber) => this.onSoundUploaded(ipfsHash, loopNumber));
    }

    isRecordable() {
        return true;
    }

    onSoundUploaded(soundId, loopNumber) {
        /*
        this.soundIds.splice(this.soundIds.indexOf(loopNumber), 1);
        let sampler = this.samplers[loopNumber];
        delete this.samplers[loopNumber];
        this.samplers[soundId] = sampler;
        let playing = this.pattern.loopsPlaying[loopNumber];
        delete this.pattern.loopsPlaying[loopNumber];
        this.pattern.loopsPlaying[soundId] = playing;
        this.soundIds.push(soundId);
        */
    }

    setAudioInputManager(audioInputManager) {
        this.audioInputManager = audioInputManager;
        this.audioInputManager.monitorVolume.gain.value = 0;
    }

    setAudioInput(channel) {
        if (this.audioInputChannel !== undefined) {
            // first disconnect
            this.disconnectAudioInput(this.audioInputChannel);
        }

        this.audioInputChannel = channel;
        if (channel !== undefined) {
            this.audioInputManager.connect(this.gainNode, channel);
            this.recorder = this.audioInputManager.getRecorder();
        } else {
            this.disconnectAudioInput(this.audioInputChannel);
        }
    }

    disconnectAudioInput(channel) {
        console.log('disconnecting channel = ' + channel);
        this.audioInputManager.disconnect(this.gainNode, channel)
        this.audioInputChannel = undefined;
    }

    isAudioInputChannelConnected(channel) {
        return this.audioInputChannel === channel;
    }

    recording(isRecording) {
        this.isRecording = isRecording;
    }

    startRecording(time) {
        if (this.recorder !== undefined) {
            let self = this;
            let milli = getMilliseconds(time);
            setTimeout(() =>{
                //console.log('recording time out now = ' + new Tone.Time(Tone.now()).toMillseconds());
                self.recorder.clear();
                self.recorder.record();
            }, milli + DELAY);
        }
    }

    stopRecording(time) {
        if (this.recorder !== undefined) {
            let self = this;
            setTimeout(() => {
                self.recorder.stop();
                self.recorder.getBuffer((blob) => {
                    self.saveBuffer(blob);
                });
            }, getMilliseconds(time) + OVERLAP);
        }
    }

    async saveBuffer(blob) {
        let self = this;
        var samplerData = {
                slices: undefined,
                offset: 0,
                transpose: 0,
                volume: 4,
            };
        let frameCount = blob[0].length;
        let audioBuffer = Tone.Master.context.createBuffer(2, frameCount, Tone.Master.context.sampleRate);  
        audioBuffer.copyToChannel(blob[0], 0, 0);
        // todo: stereo
        audioBuffer.copyToChannel(blob[0], 1, 0);
         
        let slices = [{startTime: 0, endTime: audioBuffer.duration}];
        // TODO: need to make this work correctly...
        let sample = new Sample();
        this.sample = sample;
        sample.isResampled = true;
        sample.tags = ['Recorded'];
        sample.name = "Recorded";
        sample.audioBuffer = audioBuffer;
        this.freeze([sample]);

        let id = await this.soundUploader.uploadBufferToIpfs(blob, true, 0);
        sample.ipfsHash = id;
    }

    // Called when a Sampler has been instantiated.
    // Loads the effects, connects to a Tone gainNode (the output node for the track)
    // and sets the volume for the track
    onNewRecordedSampler(self, sampler) {
        sampler.gainNode.connect(this.gainNode);
        //this.muteableNode.connect(this.gainNode);
        // connect the effects (currently there are none, it'll just connect to the master node)
        self.switchToPattern(self.currentPattern);
        // set volume to value save
        self.setVolume(self.getVolume());
        self.setPanning(self.getPanning());
    }

}

export default RecordableTrack;
